<template>
<header id="header">
  <div class="img">
    <router-link to="/">
      <img src="@/assets/images/logo2.png" alt="Grupo MLA">
    </router-link>
    <i @click="open = !open" class="menu fa" :class="[open ? 'fa-times' : 'fa-bars']"></i>
  </div>

  <nav :class="{'active' : open}">
    <div class="btn-cir azul">
      <routerLink to="/mayra" class="enlace">
      <img src="@/assets/images/svgs/frutasMayra.svg" alt="frutas mayra" height="100%">
      </routerLink>
    </div>
    <div class="btn-cir negro">
      <routerLink to="/outlandish" class="enlace">
      <img src="@/assets/images/svgs/outlandish.svg" alt="outlandish" height="100%">
      </routerLink>
    </div>
    <div class="btn-cir verde">
      <routerLink to="/modernman" class="enlace">
      <img src="@/assets/images/svgs/modernman.svg" alt="modernman" height="100%">
      </routerLink>
    </div>
    <div class="btn-cir blanco">
      <routerLink to="/maynekman" class="enlace">
      <img src="@/assets/images/svgs/mainekman.svg" alt="maynek" height="100%">
      </routerLink>
    </div>
  </nav>

    <div id="nav">
      <div class="btn"><router-link to="/productos" class="enlace">Productos</router-link></div>
      <div class="btn"><router-link to="/empresa" class="enlace">Empresa</router-link></div>
      <div class="btn"><router-link to="/recetas" class="enlace">Recetas</router-link></div>
      <div class="btn"><router-link to="/contacto" class="enlace">
      <img src="@/assets/images/email.png" alt="contacto">
      </router-link></div>
    </div>
</header>
</template>

<script>
export default {
  data() {
    return {
      open: false,
    };
  },
  mounted() {
    const buttons = this.$el.querySelectorAll('.btn-cir a');
    buttons.forEach((button) => {
      button.addEventListener('click', () => { this.open = false; });
    });
  },
};
</script>

<style lang="scss" scoped>
  #header {
    position: relative;
    .img{
      position: absolute;
      left: 10%;
     width: 15vw;
     z-index: 100;
     .menu {
       display: none;
       position: absolute;
       top: 30%;
       right: 20px;
       font-size: 4em;
     }
      :hover {
        transform: scale(1.1);
      }
      img {
        width: 100%;
        transition: all ease .3s;
      }
    }

    nav {
      display: flex;
      justify-content: flex-end;
      padding: 1% 7%;
      transition: all ease-out .7s;
      :hover {
        transform: scale(1.1);
      }

      .azul {
        background: #26347b;
      }

      .negro {
        background-color: #000;
      }

      .verde {
        background-color: #d5e18f;
      }

      .blanco {
        background-color: #fff;
        box-shadow: inset #00000090 -1px -1px 1px 1px;
      }

      .btn-cir {
        display: inline-block;
        padding: 5px 10px;
        border-radius: 300px;
        overflow: hidden;
        width: 200px;
        height: 70px;
        margin: 20px 10px;
        transition: all ease-out .7s;
        // :hover {
        //   transform: scale(1.1);
        // }
      }
    }
    .enlace {
      text-decoration: none;
    }

    #nav {
      display: flex;
      justify-content: flex-end;
      padding: 0px  9%;
      background-color: #25357a;
      :hover {
        transform: scale(1.1);
      }

      .btn {
        margin: 10px 20px;
        display: flex;
        align-items: center;
        transition: all ease-in-out .3s;

        span {
          width: 20px;
        }

        .enlace {
          color: #fff;
          font-weight: bold;
          img {
            height: 20px;
          }
        }
      }

    }
  }
  @media screen and (max-width: 500px) {
    #header .img {
      position: relative;
      text-align: center;
      width: 100%;
      left: 0;
      overflow-y: hidden;
      padding-bottom: 10px;
      .menu {
        display: block;

      }
      img {
        width: 40%;
      }
    }
    #header nav {
      flex-flow: column;
      align-items: center;
      justify-content: center;

      &:not(.active) {
        display: none;
      }
      .btn-cir {
        height: 50px;
      }
    }
  }
</style>
